import { useQuery } from '@tanstack/react-query';
import type { SupabaseClient } from '@supabase/supabase-js';
import type {
  PricingDisplayCatalog,
  PricingDisplayQuote,
} from '@/lib/billing/pricingDisplay';

export function usePricingDisplayCatalog(
  client: SupabaseClient,
  platform: 'forkhire' | 'forkseek',
  enabled = true,
) {
  return useQuery<PricingDisplayCatalog>({
    queryKey: ['pricing-display-catalog', platform],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await client.functions.invoke('pricing-display', {
        body: { platform, mode: 'catalog' },
      });
      if (error) throw error;
      return data as PricingDisplayCatalog;
    },
  });
}

export function usePricingDisplayQuote(
  client: SupabaseClient,
  platform: 'forkhire' | 'forkseek',
  request: Record<string, unknown> | null,
) {
  const requestKey = request ? JSON.stringify(request) : null;
  return useQuery<PricingDisplayQuote>({
    queryKey: ['pricing-display-quote', platform, requestKey],
    enabled: Boolean(request),
    staleTime: 60 * 1000,
    queryFn: async () => {
      const { data, error } = await client.functions.invoke('pricing-display', {
        body: { platform, ...request },
      });
      if (error) throw error;
      return data as PricingDisplayQuote;
    },
  });
}
